import { FC } from 'react';

import c from 'utils/constants';
import { Formik, type FormikHelpers } from 'formik';
import { dayjs } from 'utils/providers/Timezone';
import EventForm from 'modules/account/calendar/forms/EventForm';
import {
  EVENT_FORM,
  EVENT_SCHEMA,
} from 'modules/account/calendar/forms/schema';
import { useCreateEvent } from 'modules/account/calendar/hooks';
import getNextTime from 'modules/account/calendar/utils/getNextTime';

import { ComponentToRenderGenericProps } from '../GlobalCreate';

const INIT_FORM = {
  title: '',
  date: dayjs().toDate(),
  startAt: getNextTime(),
  endAt: getNextTime(15),
  description: '',
  guests: [],
  eventUrl: null,
  notifyBefore: 10,
  type: 'VIDEO',
};

type EventProps = ComponentToRenderGenericProps;

const Event: FC<EventProps> = ({ close }) => {
  const { mutate: createEvent, isLoading: createLoading } = useCreateEvent();

  const onSubmit = (
    { startAt, endAt, date, ...rest }: EVENT_FORM,
    { setSubmitting }: FormikHelpers<EVENT_FORM>,
  ) => {
    const d = dayjs(date).format('YYYY-MM-DD');

    const payload = {
      ...rest,
      startAt: dayjs(`${d}T${startAt}:00`, c.DATE_FORMAT).toISOString(),
      endAt: dayjs(`${d}T${endAt}:00`, c.DATE_FORMAT).toISOString(),
    };

    createEvent(payload as any, {
      onSuccess: () => {
        close();
      },
      onSettled: () => {
        setSubmitting(false);
      },
    });
  };

  return (
    <div className="flex flex-col">
      <Formik<EVENT_FORM>
        initialValues={INIT_FORM}
        validationSchema={EVENT_SCHEMA}
        onSubmit={onSubmit}
      >
        {() => <EventForm isLoading={createLoading} />}
      </Formik>
    </div>
  );
};

export default Event;
